<template>
  <vue-modal :ref="modalId" :name="modalId" :width="520" height="auto">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Save Report</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">x</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container px-0">
          <div class="form-group form-row align-items-center">
            <label for="instant-report-name" class="m-1 font-weight-bold">Report Name</label>
            <input v-model="clientReport.title" id="instant-report-name" name="name" type="text" class="form-control col-8 w-100" />
          </div>
          <div class="save-container form-group form-row p-2">
            <div class="form-inline col">
              <input type="radio" v-model="saveOption" name="save-instant-report" value="save" @change="handleSaveOptionChange" />
              <label for="save-instant-report" class="ml-1">Save</label>
            </div>
            <div class="form-inline col">
              <input type="radio" v-model="saveOption" name="save-instant-report" value="saveAsNew" @change="handleSaveOptionChange" />
              <label for="save-instant-report" class="ml-1">Save As New</label>
            </div>
          </div>
          <div v-show="statusMessage != ''" class="form-group form-row p-2">
            <div class="col-12 text-primary">{{ statusMessage }}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" :disabled="isProcessing" @click="saveReport">
          <span>Save</span>
          <span v-show="isProcessing" class="spinner-border spinner-border-sm"></span>
        </button>
        <button type="button" class="btn btn-primary ml-2" @click="closeModal">Close</button>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import AdminService from "../services/admin.service";
import ReportService from "../services/report.service";
import ClientService from "../services/client.service";
export default {
  name: "PrintInstantReportModal",
  data() {
    return {
      clientReport: {
        title: "",
        subTitle: "",
        clientReportId: 0,
        includeCoverPage: "Y",
        includeContentPage: "N",
        includeEndPage: "Y",
        pin: "N"
      },
      saveOption: "saveAsNew",
      statusMessage: "",
      isProcessing: false
    };
  },
  props: {
    clientReportId: {
      type: Number,
      default: 0
    },
    existingClientReport: {
      type: Object,
      default: function() {
        return null;
      }
    },
    defaultTitle: {
      type: String,
      default: ""
    },
    defaultSubTitle: {
      type: String,
      default: ""
    },
    beforeGenerateReport: {
      type: Function,
      default: null
    },
    modalId: {
      type: String,
      default: "print-instant-report-modal"
    }
  },
  methods: {
    syncSaveOption() {
      this.saveOption = this.clientReport.clientReportId != 0 ? "save" : "saveAsNew";
    },
    buildDefaultClientReport() {
      return {
        title: this.defaultTitle,
        subTitle: this.defaultSubTitle,
        clientReportId: 0,
        includeCoverPage: "Y",
        includeContentPage: "N",
        includeEndPage: "Y",
        pin: "N"
      };
    },
    getDownloadFilename() {
      let reportTitle = this.clientReport.title;
      if (typeof reportTitle != "string" || reportTitle.trim() == "") {
        reportTitle = this.defaultTitle;
      }
      return reportTitle + ".pptx";
    },
    clickLink(blob) {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.getDownloadFilename();
      link.click();
      URL.revokeObjectURL(link.href);
    },
    downloadItemCallback(response) {
      const blob = new Blob([response.data], { type: "application/pptx" });
      this.clickLink(blob);
      this.statusMessage = "Report is available to view.....";
      this.isProcessing = false;
      AdminService.displaySuccessMessage({ text: "Download Complete" });
    },
    async saveInstantReportCallback(response) {
      if (response.data.statusCode == 200) {
        const data = response.data.data || {};
        const savedClientReportId = data.clientReportId || this.clientReportId;
        if (typeof this.beforeGenerateReport == "function") {
          await this.beforeGenerateReport(savedClientReportId);
        }
        // wrap around 3 second time out to ensure that any asynchronous processing needed to prepare the report for generation is completed before the generation api is called.
        let vm = this;
        setTimeout(() => {
          ReportService.generateInstantPowerPointReport(savedClientReportId, true, vm.downloadItemCallback, vm);
        }, 3000);
      } else {
        this.isProcessing = false;
        this.statusMessage = "";
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    saveReport() {
      this.statusMessage = "Saving report.........";
      this.isProcessing = true;
      this.clientReport.clientId = ClientService.getClientId();
      ReportService.saveInstantClientReport(this.clientReport.clientReportId, this.clientReport, this.saveInstantReportCallback, this);
    },
    closeModal() {
      if (this.$refs[this.modalId] != null) {
        this.$refs[this.modalId].visible = false;
      }
      this.statusMessage = "";
      this.isProcessing = false;
    },
    applyExistingClientReport(existingClientReport) {
      if (existingClientReport != null && typeof existingClientReport == "object") {
        this.clientReport = {
          ...this.buildDefaultClientReport(),
          ...existingClientReport
        };
        this.syncSaveOption();
      }
    },
    handleSaveOptionChange() {
      if (this.saveOption == "saveAsNew") {
        this.clientReport = this.buildDefaultClientReport();
      } else {
        this.clientReport = this.buildDefaultClientReport();
        this.applyExistingClientReport(this.existingClientReport);
        this.clientReport.clientReportId = this.clientReportId;
      }
    },
    initializeClientReport() {
      this.clientReport = this.buildDefaultClientReport();
      this.applyExistingClientReport(this.existingClientReport);
      if (this.clientReport.clientReportId == 0) {
        this.clientReport.clientReportId = this.clientReportId;
      }
      this.syncSaveOption();
    }
  },
  created() {
    this.initializeClientReport();
  },
  watch: {
    clientReportId: function(newValue) {
      this.clientReport.clientReportId = newValue;
      this.syncSaveOption();
    },
    existingClientReport: function(newValue) {
      this.initializeClientReport();
    },
    defaultTitle: function(newValue) {
      // if it is not empty
      if (typeof newValue == "string" && newValue.trim() != "") {
        if (this.saveOption == "saveAsNew" || (typeof this.clientReport.title != "string" || this.clientReport.title.trim() == "")) {
          this.clientReport.title = newValue;
        }
      }
    },
    defaultSubTitle: function(newValue) {
      // if it is not empty
      if (typeof newValue == "string" && newValue.trim() != "") {
        if (this.saveOption == "saveAsNew" || (typeof this.clientReport.subTitle != "string" || this.clientReport.subTitle.trim() == "")) {
          this.clientReport.subTitle = newValue;
        }
      }
    }

  }
};
</script>
